<template>
  <div id="dynamicForm">
    <div v-html="ee" style="width: 100%;background-color: white;height: 300px;margin-bottom: 30px;"></div>
    <el-button @click="attempt">默认按钮</el-button>
    <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="input" style="margin:30px 0px 30px 0px;"></el-input>
    <div id="id"></div>
  </div>
</template>
<script>
  import xspreadsheet from 'x-data-spreadsheet'
  export default {
    data() {
      return {
        input: '',
        ee: '',
        showToolbar: true,
        showGrid: true,
        showContextmenu: true,
        view: {
          height: document.documentElement.clientHeight,
          width: document.documentElement.clientWidth,
        },
        row: {
          len: 100,
          height: 25,
        },
        col: {
          len: 26,
          width: 100,
          indexWidth: 60,
          minWidth: 60,
        },
        style: {
          bgcolor: '#ffffff',
          align: 'left',
          valign: 'middle',
          textwrap: false,
          strike: false,
          underline: false,
          color: '#0a0a0a',
          font: {
            name: 'Helvetica',
            size: 10,
            bold: false,
            italic: false,
          }
        }
      }
    },
    mounted() {
      const x = new xspreadsheet(document.getElementById('id'));
    },
    methods: {
      attempt() {
        console.log('开始')
        //覆盖浏览器粘贴事件
        document.addEventListener('paste', function (e) {
          var clipboardData = e.clipboardData;
          console.log(clipboardData)
          var copy_content = e.clipboardData.getData('text/plain');
          console.log(copy_content)
          this.ee = " "
        })
      }
    }
  }
</script>
<style scoped lang="scss">

</style>
<style lang="scss">
#dynamicForm {

}
</style>
